import Repository from "../../repository";

export default {
    Get: (payload) => Repository.post(`/api/BusVehicles/Get`, payload),
    GetActive: (payload) => Repository.post(`/api/BusVehicles/GetActive`, payload),
    GetById: (payload) => Repository.post(`/api/BusVehicles/GetById`, payload),
    Add: (payload) => Repository.post(`/api/BusVehicles/Add`, payload),
    Edit: (payload) => Repository.post(`/api/BusVehicles/Edit`, payload),
    Delete: (payload) => Repository.post(`/api/BusVehicles/Delete`, payload),
    ChangeStatus: (payload) => Repository.post(`/api/BusVehicles/ChangeStatus`, payload),
}